export default __webpack_public_path__ + "static/media/amDotNetv1.dca67acc.jpg";